// extracted by mini-css-extract-plugin
module.exports = {"container":"RadioSwitch_container__1f_sI","switch":"RadioSwitch_switch__27R05","slider":"RadioSwitch_slider__3ySTd"};